var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReasonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.523323 22.4271C0.686281 16.5365 1.74314 8.02342 4.93513 2.16858C5.15993 1.75624 5.56218 1.4741 6.027 1.4071C7.6008 1.18025 10.8087 0.875 15.2614 0.875C19.037 0.875 22.2176 1.25288 24.246 1.60592C25.2381 1.77857 25.7566 2.82784 25.3582 3.7526L21.6019 12.4719C25.0007 12.5979 27.4481 12.9053 29.8535 13.5429C30.7577 13.7825 31.2232 14.7591 30.8035 15.595C27.9847 21.2089 19.6294 31.7934 7.07626 40.875C7.07626 34.6189 8.17486 30.3133 10.1 24.075H2.15C1.23873 24.075 0.498123 23.338 0.523323 22.4271Z",
    fill: "#FCFF74",
    stroke: "#020202",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9953,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonIcon);
export default __webpack_public_path__ + "static/media/reason_icon.5a30587d366123e2ef8a378db720bafb.svg";
export { ForwardRef as ReactComponent };